import React from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { getPrayerWallItems, setViewSidebar } from 'features/sidebar/sidebarSlice'
import dayjs from 'dayjs'

export default function EventsFeed() {

    const { eventItem, getEventItemsStatus } = useSelector((state) => state.sidebar)

    return (
        <SidebarItemContainer>

            {
                eventItem !== null && (
                    <SBW>
                        <h2>{eventItem.name}</h2> 
                        <Color bgColor={eventItem.color}> </Color> 
                        <p>
                            {'Starts: '}
                            {dayjs(eventItem.start).format('ddd MMM DD')}
                            {' @ '}
                            {dayjs(eventItem.start).format(' h:mma')}
                        </p>
                        <p>
                            
                            {'Ends: '}
                            {dayjs(eventItem.end).format('ddd MMM DD')}
                            {' @ '}
                            {dayjs(eventItem.end).format(' h:mma')}
                        </p>
                    </SBW>
                    
                )
            }

            
        </SidebarItemContainer>
    )
}

const Color = styled.div`
    margin-top: 5px;
    margin-bottom: 5px;
    width: 100%;
    height: 14px;
    border-radius: 5px;
    background-color: ${props => props.bgColor};

`

const SBW = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start; 
    margin-top: 15px;

`

const SidebarItemContainer = styled.div` 
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    h2 {
        font-size: 1.2rem;
        font-weight: 600;
        color: var(--lightThemeFontColor);  
        margin-bottom: 5px;    
    }
    p{
        font-size: 14px;
        font-weight: 400;
        color: var(--lightThemeFontColor);
        margin-top: 5px;
    }

`